import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { LoggerService, OccEndpointsService, normalizeHttpError } from '@spartacus/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { CheckoutBillingAdapter } from './checkout.billing.adapter';

@Injectable({
  providedIn: 'root',
})
export class OccCheckoutBilingAdapter implements CheckoutBillingAdapter {
  protected logger = inject(LoggerService);

  constructor(
    protected http: HttpClient,
    protected occEndpoints: OccEndpointsService
  ) {}

  setBillingAddress(userId: string, cartId: string, billingAddressData: any): Observable<any> {
    const url = this.occEndpoints.buildUrl('checkoutBillingAddress', {
      urlParams: { userId, cartId },
    });

    return this.http
      .post<any>(url, billingAddressData)
      .pipe(catchError((error) => throwError(normalizeHttpError(error, this.logger))));
  }

  selectBillingAddress(userId: string, cartId: string, addressId: string): Observable<any> {
    const url = this.occEndpoints.buildUrl('checkoutSelectBillingAddress', {
      urlParams: { userId, cartId, addressId },
    });

    return this.http
      .put<any>(url, null)
      .pipe(catchError((error) => throwError(normalizeHttpError(error, this.logger))));
  }
}
